module.exports = __webpack_public_path__ + "static/Compute-Software-Service-Level-Standards-6a344c72ed589e2f75434752a6052ee2.pdf";